<style>
.page-item {
  cursor: pointer;
}
</style>

<template>
  <section class="content">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12">
          <h3 class="card-title">Daftar Barang</h3>
        </div>
      </div>

      <div class="row">
        <div class="col-12" style="padding-bottom: 10px">
          <button v-if="$gate.isAdmin1()" type="button" class="btn btn-sm btn-primary" @click="newModal">
            <i class="fa fa-plus-square"></i>
            Tambah Barang
          </button>
        </div>
      </div>

      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="card-header">
              Menampilkan
              <select v-model.number="perPage" @change="changePageRange">
                <option value="10">10</option>
                <option value="20">20</option>
                <option value="50">50</option>
                <option value="100">100</option>
                <!--<option value="0">ALL</option>-->
              </select>
              Data
              <div class="card-tools">
                <input type="text" v-model="searchTerm" placeholder="Cari" />
              </div>
            </div>
            <!-- /.card-header -->
            <div class="card-body table-responsive p-0">
              <table class="table table-hover" id="my-table">
                <thead>
                  <tr>
                    <!--th>ID</th-->
                    <th role="button" v-on:click="sortRecords('nama_barang', 'barang')">Nama Barang</th>
                    <th role="button" v-on:click="sortRecords('Nama', 'kategori_barang')">Kategori</th>
                    <th role="button" v-on:click="sortRecords('nama', 'satuan')">Satuan</th>
                    <th role="button" v-on:click="sortRecords('keterangan', 'barang')">Keterangan</th>
                    <th role="button" v-on:click="sortRecords('status_sementara', 'barang')">Status</th>
                    <!--<th>Action</th>-->
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="barang in barangs.data" :key="barang.id">
                    <!--td>{{ruang.id}}</td-->
                    <td class="text-capitalize">{{ barang.nama_barang }}</td>
                    <td>{{ barang.nama_kategori_barang }}</td>
                    <td>{{ barang.nama_satuan }}</td>
                    <td>{{ barang.keterangan }}</td>
					<td>
					  <span v-if="barang.status_sementara == 1" class="badge badge-warning">
						Sementara
					  </span>
					  <span v-else class="badge badge-success">
						Tetap
					  </span>
					</td>
                    <td>
                      <a v-if="barang.id > 500000" href="#" @click="editModal(barang)">
                        <i class="fa fa-edit blue"></i>
                      </a>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <!-- /.card-body -->
            <div class="card-footer">
              <div class="row">
                <div class="col-12">
                  <pagination
                    :records="parseInt(barangs.total)"
                    v-model="page"
                    :per-page="perPage"
                    :options="{ texts: { count: 'Menampilkan data ke {from} sampai {to} dari total {count} data|{count} records|One record' } }"
                    @paginate="getResults"></pagination>
                </div>
              </div>
              <div class="row">
                <div class="col-12">
                  Menampilkan
                  <select v-model.number="perPage" @change="changePageRange">
                    <option value="10">10</option>
                    <option value="20">20</option>
                    <option value="50">50</option>
                    <option value="100">100</option>
                    <!--<option value="0">ALL</option>-->
                  </select>
                  Data
                </div>
              </div>
            </div>
          </div>
          <!-- /.card -->
        </div>
      </div>

      <div v-if="!$gate.isAdmin1()">
        <not-found></not-found>
      </div>

      <!-- Modal -->
      <div class="modal fade" id="addNew" tabindex="-1" role="dialog" aria-labelledby="addNew" aria-hidden="true">
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" v-show="!editmode">Tambah Barang</h5>
              <h5 class="modal-title" v-show="editmode">Ubah Barang</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>

            <!-- <form @submit.prevent="createUser"> -->

            <form @submit.prevent="editmode ? updateBarang() : createBarang()">
              <div class="modal-body">
                <div class="form-group">
                  <label>Nama Barang</label>
                  <input v-model="form.nama_barang" type="text" name="nama_barang" class="form-control" :class="{ 'is-invalid': form.errors.has('nama') }" />
                  <has-error :form="form" field="nama_barang"></has-error>
                </div>
                <div class="form-group">
                  <label>Kategori Barang</label>
                  <v-select :options="kategoris" :reduce="(kategori) => kategori.id" label="Nama" v-model="form.kategori_barang_id"></v-select>
                  <has-error :form="form" field="kategori_barang_id"></has-error>
                </div>
                <div class="form-group">
                  <label>Satuan</label>
                  <v-select :options="options" :reduce="(option) => option.id" label="nama" v-model="form.satuan_id"></v-select>
                  <has-error :form="form" field="satuan_id"></has-error>
                </div>
                <div class="form-group">
                  <label>Keterangan</label>
                  <textarea v-model="form.keterangan" name="keterangan" class="form-control" :class="{ 'is-invalid': form.errors.has('keterangan') }"> </textarea>
                  <has-error :form="form" field="keterangan"></has-error>
                </div>
				
				<div class="form-group">
				  <label>Status Sementara</label>
				  <select v-model.number="form.status_sementara" class="form-control">
					<option :value="0">Tidak</option>
					<option :value="1">Ya (Sementara)</option>
				  </select>
				  <has-error :form="form" field="status_sementara"></has-error>
				</div>
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                <button v-show="editmode" type="submit" class="btn btn-success">Simpan</button>
                <button v-show="!editmode" type="submit" class="btn btn-primary">Simpan</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import Pagination from "vue-pagination-2";

export default {
  components: {
    Pagination,
  },
  data() {
    return {
      editmode: false,
      searchTerm: "",
      limit: 0,
      barangs: {},
      kategoribarangs: {},
      kategoris: [],
      satuans: {},
      options: [],
      form: new Form({
        id: "",
        nama_barang: "",
        kategori_barang_id: "",
        satuan_id: "",
        keterangan: "",
      }),
      sortIndex: "nama_barang",
      sortDirection: "asc",
      perPage: 10,
      showTable: "barang",
      page: 1,
    };
  },
  methods: {
    sortRecords(index, tableName) {
      this.sortIndex = index;
      this.showTable = tableName;
      if (this.sortDirection == "asc") {
        this.sortDirection = "desc";
      } else if (this.sortDirection == "desc") {
        this.sortDirection = "asc";
      } else {
        this.sortDirection = "asc";
      }

      this.$Progress.start();

      this.page = 1;

      axios.get("/api/barang?sortIndex=" + this.sortIndex + "&sortDirection=" + this.sortDirection + "&showPage=" + this.perPage + "&showTable=" + this.showTable).then(({ data }) => (this.barangs = data.data.barang));

      this.$Progress.finish();
    },
    changePageRange() {
      this.$Progress.start();

      this.page = 1;

      axios.get("/api/barang?sortIndex=" + this.sortIndex + "&sortDirection=" + this.sortDirection + "&showPage=" + this.perPage + "&showTable=" + this.showTable).then(({ data }) => (this.barangs = data.data.barang));

      this.$Progress.finish();
    },
    getResults(page = 1) {
      this.$Progress.start();

      axios.get("/api/barang?page=" + page + "&sortIndex=" + this.sortIndex + "&sortDirection=" + this.sortDirection + "&showPage=" + this.perPage + "&showTable=" + this.showTable).then(({ data }) => (this.barangs = data.data.barang));

      this.$Progress.finish();

      /*let param = _.isEmpty(this.searchTerm) ? 'all' : this.searchTerm;
                  this.$Progress.start();                  
                  axios.get('/api/barang?search='+ param +'&page=' + page).then(({ data }) => (this.barangs = data.data.barang));
                  this.$Progress.finish();*/
    },
    updateBarang() {
      this.$Progress.start();
      this.form
        .put("/api/barang/" + this.form.id)
        .then((response) => {
          // success
          $("#addNew").modal("hide");
          Toast.fire({
            icon: "success",
            title: response.data.message,
          });
          this.$Progress.finish();
          //  Fire.$emit('AfterCreate');

          this.loadBarangs();
        })
        .catch(() => {
          this.$Progress.fail();
        });
    },
    editModal(barang) {
      this.editmode = true;
      this.form.reset();
      $("#addNew").modal("show");
      this.form.fill(barang);
    },
    newModal() {
      this.editmode = false;
      this.form.reset();
      $("#addNew").modal("show");
    },
    eksporBarang() {
      let routeData = this.$router.resolve({ path: "/export-barang", query: { data: "data" } });
      window.open(routeData.href, "_blank");
    },
    loadKategoris() {
      axios.get("/api/kategori_barang/objlist").then(({ data }) => ((this.kategoribarangs = data.data), (this.kategoris = data.data)));
    },
    loadSatuans() {
      axios.get("/api/satuan/objlist").then(({ data }) => ((this.satuans = data.data), (this.options = data.data)));
    },
    loadBarangs() {
      this.$Progress.start();

      let param = _.isEmpty(this.searchTerm) ? "all" : this.searchTerm;
      if (this.$gate.isAdmin1()) {
        axios.get("/api/barang?search=" + param + "&sortIndex=" + this.sortIndex + "&sortDirection=" + this.sortDirection + "&showPage=" + this.perPage + "&showTable=" + this.showTable).then(({ data }) => (this.barangs = data.data.barang));
      }

      this.$Progress.finish();

      /*let param = _.isEmpty(this.searchTerm) ? 'all' : this.searchTerm;
                if(this.$gate.isAdmin1()){
                    axios.get("/api/barang?search=" + param).then(({ data }) => (this.barangs = data.data.barang));
                }         */
    },

    createBarang() {
      this.form
        .post("/api/barang")
        .then((response) => {
          $("#addNew").modal("hide");

          Toast.fire({
            icon: "success",
            title: response.data.message,
          });

          this.$Progress.finish();
          this.loadBarangs();
        })
        .catch(() => {
          Toast.fire({
            icon: "error",
            title: "Some error occured! Please try again",
          });
        });
    },
    callback() {
      console.log(`Page ${page} was selected. Do something about it`);
    },
  },
  mounted() {
    console.log("Component mounted.");
  },
  created() {
    this.$Progress.start();
    this.loadBarangs();
    this.loadKategoris();
    this.loadSatuans();
    this.$Progress.finish();
  },
  watch: {
    searchTerm: function () {
      this.loadBarangs();
    },
  },
};
</script>
